import React from "react";
import classnames from "classnames";
import { LoadingOutlined } from "@ant-design/icons";

const Icon = ({
  style,
  loading,
  name,
  className,
  onClick,
  fontSize,
  paddingless = false,
  color,
}) => {
  if (loading) {
    return (
      <LoadingOutlined
        className={classnames(className, {
          "px-xs py-xs text-blue": !paddingless,
        })}
        style={{
          fontSize,
          ...style,
        }}
      />
    );
  }
  return (
    <i
      className={classnames(`icon-${name} `, color, className, {
        "cursor-pointer": onClick,
        "px-xs py-xs": !paddingless,
      })}
      onClick={onClick}
      style={{
        fontSize,
        ...style,
      }}
    />
  );
};

export default Icon;
